import Vue from 'vue'
export default new Vue



//////////////////
// WEBPACK FOOTER
// ./common/util.js
// module id = null
// module chunks = 